import type { Message as MessageType } from "../../../types/index";

export function Message({
  sender,
  avatar,
  time,
  content,
  isCurrentUser,
}: MessageType) {
  return (
    <div className={`flex ${isCurrentUser ? "justify-end" : "justify-start"}`}>
      <div
        className={`flex items-start max-w-[85%] md:max-w-2xl ${
          isCurrentUser ? "flex-row-reverse" : "flex-row"
        }`}
      >
        {!isCurrentUser && (
          <img
            src={
              avatar ||
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
            }
            alt={sender}
            className="w-8 h-8 rounded-full mx-2"
          />
        )}
        <div>
          <div className="flex items-center">
            <span className="text-xs md:text-sm text-gray-500">{time}</span>
          </div>
          <div
            className={`mt-1 rounded-lg p-2.5 md:p-3 ${
              isCurrentUser
                ? "bg-blue-500 text-white"
                : "bg-gray-100 text-gray-900"
            }`}
          >
            <p className="text-sm md:text-base break-words">{content}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
